import React from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import { pickerFieldSX } from "../utils/formField";

/**
 * App-wide date picker. Consistent "DD-MM-YYYY" display and the MUI calendar dropdown.
 * Works with plain "YYYY-MM-DD" strings so it drops into existing string-based form
 * state — value in, value out.
 */
export type AppDatePickerProps = {
  value: string; // "YYYY-MM-DD" or ""
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  /** Bounds, as "YYYY-MM-DD". */
  minDate?: string;
  maxDate?: string;
  fullWidth?: boolean;
};

const AppDatePicker: React.FC<AppDatePickerProps> = ({
  value,
  onChange,
  disabled,
  error,
  helperText,
  minDate,
  maxDate,
  fullWidth = true,
}) => (
  <DesktopDatePicker
    format="DD-MM-YYYY"
    value={value ? dayjs(value, "YYYY-MM-DD") : null}
    onChange={(d) => onChange(d && d.isValid() ? d.format("YYYY-MM-DD") : "")}
    minDate={minDate ? dayjs(minDate, "YYYY-MM-DD") : undefined}
    maxDate={maxDate ? dayjs(maxDate, "YYYY-MM-DD") : undefined}
    disabled={disabled}
    slotProps={{
      textField: { fullWidth, sx: pickerFieldSX, error, helperText },
    }}
  />
);

export default AppDatePicker;
